export const SocialProofBar: React.FC = () => {
  return (
    <section className="lp-stats-section">
      <div className="lp-stats-container">
        <div className="lp-stat-item">
          <div className="lp-stat-icon">
            <img src="/landing/Icon_timer.svg" alt="" width={40} height={40} />
          </div>
          <div className="lp-stat-text">
            <h3 className="lp-stat-title">Spart 4 Stunden</h3>
            <p className="lp-stat-desc">Zeit pro Immobilie – für Bildbearbeitung und Overlays</p>
          </div>
        </div>
        <div className="lp-stat-item">
          <div className="lp-stat-icon">
            <img src="/landing/Icon_Expose.svg" alt="" width={40} height={40} />
          </div>
          <div className="lp-stat-text">
            <h3 className="lp-stat-title">Bessere Exposés</h3>
            <p className="lp-stat-desc">Professionelle Bilder, die den Unterschied machen.</p>
          </div>
        </div>
        <div className="lp-stat-item">
          <div className="lp-stat-icon">
            <img src="/landing/Icon_Money.svg" alt="" width={40} height={40} />
          </div>
          <div className="lp-stat-text">
            <h3 className="lp-stat-title">Höherer Verkaufspreis</h3>
            <p className="lp-stat-desc">Virtuelles Staging kann Immobilienpreise um 5–10 % steigern</p>
          </div>
        </div>
      </div>
    </section>
  );
};
